// Tiny helpers to persist an in-progress form locally so entries survive a
// connection drop, reload or accidental navigation. Backed by localStorage.
//
// Datenschutz/Sicherheit:
// - Entwürfe können personenbezogene Daten (Namen, Adressen, Kontaktdaten)
//   enthalten. Sie werden daher (a) obfuskiert statt im Klartext abgelegt,
//   (b) nach Ablauf der TTL automatisch verworfen und (c) besonders sensible
//   biometrische Felder (Unterschriften) werden gar nicht erst persistiert.

const DRAFT_TTL_MS = 24 * 60 * 60 * 1000; // 24h – Entwuerfe verfallen automatisch

// Biometrische / besonders schuetzenswerte Felder werden nie lokal gespeichert.
const SENSITIVE_FIELDS = ["technicianSignature", "customerSignature"];

// Leichte Obfuskation (kein Ersatz fuer echte Verschluesselung): verhindert das
// beilaeufige Auslesen von PII in den DevTools/localStorage. UTF-8-sicher.
function encode(str) {
  return btoa(unescape(encodeURIComponent(str)));
}
function decode(str) {
  return decodeURIComponent(escape(atob(str)));
}

function stripSensitive(values) {
  if (!values || typeof values !== "object") return values;
  const clean = { ...values };
  for (const key of SENSITIVE_FIELDS) delete clean[key];
  return clean;
}

export function loadFormDraft(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    let parsed;
    try {
      parsed = JSON.parse(decode(raw));
    } catch {
      // Legacy-Format (unobfuskierter Klartext) tolerieren, aber sofort bereinigen.
      try {
        const legacy = JSON.parse(raw);
        localStorage.removeItem(key);
        return stripSensitive(legacy);
      } catch {
        localStorage.removeItem(key);
        return null;
      }
    }

    if (!parsed || typeof parsed !== "object" || parsed.v !== 1) {
      localStorage.removeItem(key);
      return null;
    }

    // Abgelaufene Entwuerfe verwerfen.
    if (!parsed.ts || Date.now() - parsed.ts > DRAFT_TTL_MS) {
      localStorage.removeItem(key);
      return null;
    }

    return parsed.data ?? null;
  } catch {
    return null;
  }
}

export function saveFormDraft(key, values) {
  const payload = { v: 1, ts: Date.now(), data: stripSensitive(values) };
  try {
    localStorage.setItem(key, encode(JSON.stringify(payload)));
    return true;
  } catch (e) {
    console.error("Formularentwurf konnte nicht gespeichert werden (Speicher voll):", e);
    return false;
  }
}

export function clearFormDraft(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.error("Formularentwurf konnte nicht entfernt werden:", e);
  }
}
